import './Button.scss';
import cn from 'classnames';

const Button = ({ text, onClick, type = '' }) => {
  return (
    <div className={cn('button', type === 'primary' && 'buttonPrimary', type === 'white' && 'buttonWhite')} onClick={onClick}>
      {text}
    </div>
  );
};

export default Button;
